import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DocumentService } from '@app/shared/services';
import { AddEditPropertyValueComponent } from './add-edit-property-value/add-edit-property-value.component';
import { FetchAttributeDataSubject } from '../add-finacial-attribute/attribute-subject.service';
import { AddApiRapidValueService } from '../add-api-rapid-value.service';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'add-api-rapid-property-value',
  templateUrl: './add-api-rapid-property-value.component.html',
  styleUrl: './add-api-rapid-property-value.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddApiRapidPropertyValueComponent implements OnInit, OnDestroy {
  isDataLoading = true;
  @Output() updateActionItemProperty = new EventEmitter<string>();

  apiMotorValueList = [];
  allowEditPermission = true;
  @Input() mode;
  @Input() currentFormId;
  @Input() templateId = null;
  @Input() rapidAPISetupData;
  selectedFileList = [];
  subscription = new Subscription();
  formSetupData;
  private AddApiRapidValueService = inject(AddApiRapidValueService);
  constructor(
    private dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private _documentService: DocumentService,
    private attributeSubject: FetchAttributeDataSubject
  ) {}

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  editMotor() {
    this.addEditMotorData();
  }

  addEditMotorData() {
    this.formSetupData = this.rapidAPISetupData.find((r) => r.sub_type === 'Zillow');
    const childDialog = this.dialog.open(AddEditPropertyValueComponent, {
      height: '100%',
      data: {
        currentFormId: this.currentFormId,
        is_edit: this.apiMotorValueList && this.apiMotorValueList.length > 0 ? true : false,
        apiMotorValueList: this.apiMotorValueList,
        formSetupData: this.formSetupData,
        templateId: this.templateId,
      },
      panelClass: 'full-window-dialog',
    });
    this.subscription.add(
      childDialog.afterClosed().subscribe(
        (data) => {
          this.isDataLoading = true;
          this.AddApiRapidValueService.addEditPropertySubjectData.next(null);

          this.cd.detectChanges();
          if (data?.success) {
            this.attributeSubject.handleFetchData(true);
            this.updateActionItemProperty.emit('complete');
          }
          this.getVehicleData();
        },
        (error) => {}
      )
    );
  }

  ngOnInit(): void {
    this.subscription.add(
      this.AddApiRapidValueService.addEditPropertySubjectData.subscribe((data) => {
        if (data === 'addEditPropertyData') {
          this.addEditMotorData();
        }
      })
    );
    this.getVehicleData();
  }

  getVehicleData() {
    this.subscription.add(
      this._documentService.getVaultFormRapidIntegration(this.currentFormId).subscribe((res) => {
        this.apiMotorValueList = [];
        this.AddApiRapidValueService.propertyDataSubjectData.next(this.apiMotorValueList);
        if (res?.length && res.filter((x) => x.type == 'zillow')?.length) {
          let element = res.filter((x) => x.type == 'zillow')[0];
          element.payload = JSON.parse(element.payload);
          element.response = JSON.parse(element.response);
          element.setting = JSON.parse(element.setting);
          this.apiMotorValueList.push(element);
          this.AddApiRapidValueService.propertyDataSubjectData.next(this.apiMotorValueList);
          this.AddApiRapidValueService.setPropertyDataFromLiveFeeds(element, this.templateId);
        }
        this.isDataLoading = false;
        this.cd.detectChanges();
      })
    );
  }
}
